import * as React from "react"

const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={16}
    viewBox="0 0 7 16"
    fill="none"
    {...props}
  >
    <path
      d="M6 1L1 8L6 15"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default ChevronLeft
